import { Component, input, OnInit, output } from '@angular/core';
import { faArrowCircleRight, faArrowCircleLeft, faEdit, faCheck, faDraftingCompass, faFileExport, faSave, faAngleDoubleRight, faExclamationCircle, faUserAltSlash, faUserCheck, faHistory, faLock, faLockOpen, faSpellCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons';
import { RoadmapStatusDto, UserProfile } from 'src/app/services/application-api.service';
import { MatButton } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatTooltipModule } from '@angular/material/tooltip';

export enum ControlFunction {
  Edit,
  Update,
  UpdateAdmin,
  Delete
}
export interface IRoadmapControlFunction {
  function: ControlFunction;
  value?: string;
}

@Component({
  selector: 'roadmap-controls',
  imports: [FontAwesomeModule, MatButton, MatTooltipModule],
  templateUrl: './roadmap-controls.component.html',
  styleUrl: './roadmap-controls.component.scss'
})
export class RoadmapControlsComponent implements OnInit {
  cfEnum = ControlFunction;

  showEdit = false;
  showApprove = false;
  showReject = false;
  showPending = false;
  showSaveDraft = false;
  showApproveDryRun = false;
  showNewVersionText = false;
  showResubmitText = false;
  showEditAdmin = false;
  showUpdateAdmin = false;
  showDeleteAdmin = false;

  faArrowCircleRight = faArrowCircleRight;
  faArrowCircleLeft = faArrowCircleLeft;
  faEdit = faEdit;
  faCheck = faCheck;
  faDraftingCompass = faDraftingCompass;
  faFileExport = faFileExport;
  faSave = faSave;
  faAngleDoubleRight = faAngleDoubleRight;
  faUserCheck = faUserCheck;
  faUserAltSlash = faUserAltSlash;
  faExclamationCircle = faExclamationCircle;
  faHistory = faHistory;
  faLock = faLock;
  faLockOpen = faLockOpen;
  faSpellCheck = faSpellCheck;
  faTrash = faTrash;
  faFileAlt = faFileAlt;

  roadmapStatus = input<RoadmapStatusDto | undefined>(undefined, { alias: 'roadmapStatus' });
  inEditMode = input<boolean | undefined>(undefined, { alias: 'inEditMode' });
  appUser = input<UserProfile | undefined>(undefined, { alias: 'appUser' });
  regionCheck = input<boolean | undefined>(undefined, { alias: 'regionCheck' });
  roadmapError = input<boolean | undefined>(undefined, { alias: 'roadmapError' });
  controlFunction = output<IRoadmapControlFunction>();

  ngOnInit() {

    this.setButtonVisibilityLogic();
  }

  setButtonVisibilityLogic() {
    switch (this.roadmapStatus()?.id) {
      case 1: {
        this.showEdit = true;
        break;
      }
      case 2: {
        this.showEdit = (this.appUser()!.isAdminUser) ? true : false;
        this.showPending = (!this.appUser()!.isAdminUser && !this.regionCheck()!) ? true : false;
        //this.showApprove = this.showApproveLogic(this.hasRlm()!, this.appUser()!, this.regionCheck()!);
        //this.showReject = this.showRejectLogic(this.appUser()!, this.regionCheck()!);
        //this.showApproveDryRun = (this.hasRlm()! && this.appUser()!.adminUserRole?.name === 'IM Approver' && this.regionCheck()!) ? true : false;
        break;
      }
      case 4: {
        this.showEdit = true;
        this.showNewVersionText = true;
        break;
      }
      case 3: {
        this.showEdit = true;
        this.showResubmitText = true;
        //this.showApprove = this.showApproveLogic(this.hasRlm()!, this.appUser()!, this.regionCheck()!);
        break;
      }
      case 6: {
        this.showEdit = (this.appUser()!.isAdminUser) ? true : false;
        this.showPending = (!this.appUser()!.isAdminUser && !this.regionCheck()!) ? true : false;
        //this.showApprove = this.showApproveLogic(this.hasRlm()!, this.appUser()!, this.regionCheck()!);
        //this.showReject = this.showRejectLogic(this.appUser()!, this.regionCheck()!);
        break;
      }
      case 5: {
        this.showEdit = true;
        break;
      }
    }

    this.showEditAdmin = (this.roadmapStatus()?.name !== 'Archived' && this.appUser()?.isAdminUser) ? true : false;
    this.showDeleteAdmin = (this.roadmapStatus()?.name !== 'Archived' && this.appUser()?.isAdminUser) ? true : false;
  }

  onSubmit(func: ControlFunction, value?: string) {
      const roadmapControlFunction: IRoadmapControlFunction = ({ function: func, value });

      // send back the goal plan and close the dialog
      this.controlFunction.emit(roadmapControlFunction);
  }

  showApproveLogic(hasRlm: boolean, appUser: UserProfile, regionCheck: boolean) {
    //if (hasRlm && appUser.isRlm && regionCheck) {
      return true;
    //} else if (!hasRlm && appUser.isImApprover && regionCheck) {
    //   return true;
    // } else if (appUser.isAdminUser) {
    //   return true;
    // } else {
    //   return false;
    // }
  }

  showRejectLogic(appUser: UserProfile, regionCheck: boolean) {
    // if ((appUser.isRlm || appUser.isImApprover) && regionCheck) {
    //     return true;
    // } else if (appUser.isAdminUser) {
    //     return true;
    // } else {
    //     return false;
    // }
  }
}
